// extracted by mini-css-extract-plugin
export default {"title_box":"AuditionComponent_title_box__ZuZXb","img_box":"AuditionComponent_img_box__-C4YY"};